export enum DeductHoldingDepositFrom {
  Rent = 0,
  Deposit = 1,
}
